export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1776761604095-e8dd031864d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBlY28lMjBob3RlbCUyMGFyY2hpdGVjdHVyZSUyMG5hdHVyZXxlbnwwfHx8fDE3ODg4NTg3MDV8MA&ixlib=rb-4.1.0&q=80&w=2000&auto=format",
    hawaii:
        "https://images.unsplash.com/photo-1505852679233-d9fd70aff56d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxoYXdhaWklMjBsYW5kc2NhcGUlMjBuYXR1cmUlMjBwcmlzdGluZXxlbnwwfHx8fDE3ODg4NTg3MDV8MA&ixlib=rb-4.1.0&q=80&w=1600&auto=format",
    interior:
        "https://images.unsplash.com/photo-1761971975065-8e1fcf101303?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxob3RlbCUyMGxvYmJ5JTIwZ3JlZW4lMjBwbGFudHMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODg4NTg3MDV8MA&ixlib=rb-4.1.0&q=80&w=1400&auto=format",
    chef: "https://images.unsplash.com/photo-1572715376701-98568319fd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzdXN0YWluYWJsZSUyMGNoZWYlMjBraXRjaGVuJTIwZm9vZCUyMHdhc3RlfGVufDB8fHx8MTc4ODg1ODcwNXww&ixlib=rb-4.1.0&q=80&w=1400&auto=format",
};

export const LOGO_MARK = "/assets/ggh-mark-t.webp";
export const LOGO_FULL = "/assets/ggh-full-t.webp";

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About GGH" },
    { to: "/framework", label: "Our Framework" },
    { to: "/what-we-do", label: "What We Do" },
    { to: "/research", label: "Research & Insights" },
    { to: "/for-hotels", label: "For Hotels" },
    { to: "/sustainability-check", label: "Free Check" },
    { to: "/partners", label: "Partners" },
    { to: "/get-involved", label: "Get Involved" },
    { to: "/contact", label: "Contact" },
];

export const ORG = {
    name: "Global Green Hotel",
    short: "GGH",
    tagline: "Sustainable Hospitality • Better Planet • Stronger Business",
    location: "Waikoloa Village, Hawaiʻi, USA",
    email: "globalgreenhotel@gmail.com",
    phone: "+1 (808) 333-0466",
    phoneHref: "tel:+18083330466",
};

export const CONTACT_REASONS = [
    "Hotel partnership",
    "Sustainability collaboration",
    "Research",
    "Sponsorship",
    "Funding",
    "Technology partnership",
    "Media",
    "General inquiry",
];

export const INTEREST_AREAS = [
    "Hotels",
    "Researchers",
    "Students",
    "Organizations",
    "Sponsors",
    "Communities",
];

export const SEARCH_INDEX = [
    { title: "Home", path: "/", keywords: "home start welcome global green hotel", desc: "GGH homepage — sustainable and regenerative hospitality" },
    { title: "About GGH", path: "/about", keywords: "about story philosophy aims founder oliver ouma vision direction", desc: "Our story, philosophy and long-term direction" },
    { title: "Our Framework", path: "/framework", keywords: "framework pillars environment food people community business governance regenerative", desc: "The six-pillar GGH Sustainable Hospitality Framework" },
    { title: "What We Do", path: "/what-we-do", keywords: "services recognition assessment training reporting support areas", desc: "Seven ways GGH supports hotels" },
    { title: "Research & Insights", path: "/research", keywords: "research insights articles food waste hawaii knowledge library blog destination travel", desc: "Research focus, publications and insights" },
    { title: "Organization Profile", path: "/research/organization-profile", keywords: "organization profile pdf publication introduction", desc: "The complete introduction to Global Green Hotel" },
    { title: "Free Sustainability Check", path: "/sustainability-check", keywords: "free check mini assessment quiz how sustainable score questions starting point", desc: "Five quick questions — find your hotel's starting point" },
    { title: "For Hotels", path: "/for-hotels", keywords: "hotels membership plans essential professional leader services pathway", desc: "Membership, services and the GGH hotel pathway" },
    { title: "Join GGH", path: "/join", keywords: "join register hotel membership sign up create account", desc: "Register your hotel and become a member" },
    { title: "Member Hotels", path: "/hotels", keywords: "directory member hotels public profiles", desc: "Hotels participating in GGH" },
    { title: "Sustainable & Regenerative Travel", path: "/#travel", keywords: "travel traveler responsible tourism respect culture support local protect nature", desc: "Travel better and leave a positive impact" },
    { title: "Traveler Pledge", path: "/#pledge", keywords: "pledge traveler promise commit responsible choices", desc: "Take the GGH Traveler Pledge" },
    { title: "Support GGH", path: "/#support", keywords: "support donate financial contribution funding help impact give", desc: "Help build a more sustainable future for hospitality" },
    { title: "Reviews", path: "/reviews", keywords: "reviews community stars rating experiences share", desc: "Community reviews and experiences" },
    { title: "Partners", path: "/partners", keywords: "partners partnership collaboration funding strategic knowledge hotel", desc: "Partner with GGH" },
    { title: "Get Involved", path: "/get-involved", keywords: "get involved participate contribute interest students researchers sponsors communities", desc: "Ways to participate in the GGH movement" },
    { title: "Become a Founding Participant", path: "/get-involved#interest-form", keywords: "founding participant pioneer early shape pilot first group", desc: "Help shape GGH's early work" },
    { title: "Contact", path: "/contact", keywords: "contact email phone message reach talk inquiry", desc: "Get in touch with the GGH team" },
    { title: "Login", path: "/login", keywords: "login sign in account access member hotel", desc: "Hotel and member sign in" },
    { title: "Create Member Account", path: "/register", keywords: "register create account member sign up google free", desc: "A free account for individuals" },
    { title: "Hotel Login", path: "/hotel/login", keywords: "hotel login dashboard assessment score", desc: "Access your hotel dashboard" },
    { title: "Privacy Policy", path: "/privacy", keywords: "privacy data policy personal information", desc: "How GGH handles data" },
    { title: "Terms of Use", path: "/terms", keywords: "terms conditions legal use", desc: "Website terms and conditions" },
];
